import request from '@/utils/request'

//视频列表
export function videoList(query) {
  return request({
    url: '/api/ys/listDevice',
    method: 'post',
    params: query
  })
}

//删除设备接口
export function delDeviceApi(params) {
  return request({
    url: '/api/ys/delDevice',
    method: 'post',
    params
  })
}

//修改设备接口
export function changeDeviceApi(params) {
  return request({
    url: '/api/ys/renameDevice',
    method: 'post',
    params
  })
}

//添加设备接口
export function addDeviceApi(params) {
  return request({
    url: '/api/ys/addDevice',
    method: 'post',
    params
  })
}

//直播接口
export function getLiveApi(params) {
  return request({
    url: '/api/ys/deviceLive',
    method: 'post',
    params
  })
}
